import apiClient from "@/libs/axios";
export const state = {
    data: [],
    details: null,
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    setDetails: (state, data) => {
        state.details = data.result
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, vendor: {...item.vendor, is_active: data.vendor.is_active}} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {
    async get({ commit }, data) {
        await apiClient
            .get(`api/v1/appointments?filter[user_id]=${data.id}`)
            .then(response => {
                console.log(response.data.result.data)
                if (response.status === 200) {
                    commit('setData', response.data.result);
                }
            })
            .catch(error => {
                throw error;
            },);
    },

    async reject({ commit }, data) {
        await apiClient
            .post(`api/v1/appointments/reject`, {id: data.id, reject_reason: data.reject_reason})
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    },
    async details({ commit }, id) {
        console.log(id)
        await apiClient
            .get(`api/v1/appointments/show?id=${id}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setDetails', response.data);
                }
            })
            .catch(error => {
                throw error;
            })
    },
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getDetails(state) {
        return state.details;
    },
    getTotal(state) {
        return state.total;
    },
};
